// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    PLAYLIST_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        playlistIndexPage: action.playlistIndexPage
      };
    },
    PLAYLIST_INDEX_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.playlistIndexPage
      };
    },
    PLAYLIST_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.playlistIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
